import React from 'react';
import faker from 'faker';
import Chart from '../../../../components/organisms/chart';
import useRenderChartTotal from './hooks';

function RenderChartTotal() {
  const {
    totalSales, isLoading, setCurrentView, currentView, isDataExists,
  } = useRenderChartTotal();
  const { CustomTopContent, Default } = Chart.Overview;

  return (
    <Default
      title="Weekly Sales"
      topContent={[
        CustomTopContent('Today', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.today),
        CustomTopContent('This Week', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.week),
        CustomTopContent('This Month', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.oneMonth),
        CustomTopContent('3 Months', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.threeMonth),
        CustomTopContent('6 Months', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.sixMonth),
        CustomTopContent('1 Year', faker.datatype.number({ min: -10, max: 10 }), totalSales?.total?.year),
      ]}
      items={[
        { label: 'Snack', bgColor: 'rgb(225, 143, 80)', amount: totalSales?.data?.snack ?? [] },
        { label: 'Soda', bgColor: 'rgb(117, 192, 219)', amount: totalSales?.data?.soda ?? [] },
      ]}
      currentView={currentView}
      setCurrentView={setCurrentView}
      labels={totalSales?.data?.label ?? []}
      isData={isDataExists}
      isLoading={isLoading}
    />
  );
}

export default React.memo(RenderChartTotal);
